import {AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2} from '@angular/core';
import {UrlOpenerProvider} from "../services/url-opener.service";

@Directive({
  selector: '[catch-links]'
})
export class CatchLinksDirective implements AfterViewInit, OnDestroy {
  private unregister: () => void;

  constructor(private element: ElementRef,
              private renderer: Renderer2,
              private urlOpener: UrlOpenerProvider) {
  }

  ngAfterViewInit(): void {
    this.unregister = this.renderer.listen(this.element.nativeElement, 'click', (event) => {
      const link = event.target.closest('a');

      if (link) {
        event.preventDefault();
        event.stopImmediatePropagation();

        this.urlOpener.openUrl(decodeURI(link.href));
      }
    });
  }

  ngOnDestroy(): void {
    if (this.unregister) {
      this.unregister();
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/catch-links.ts